import { Menu } from '@design-systems/canvas-ui'
import Icon, {
  ChevronDownIcon,
  ExternalIcon,
  LinkIcon,
} from '@design-systems/react-icons'
import { useEnv } from '@praxis/component-runtime-env'
import {
  hasPermission,
  PERMISSIONS,
} from '../../../shared/roleAccess/config/roleConfig'
import { BRAND_REFERENCE_LINKS } from '../config/referenceLinksConfig'

const BrandReferenceLinks = ({ brand, role }) => {
  const env = useEnv()
  if (!hasPermission(role, PERMISSIONS.VIEW_REFERENCE_LINKS)) return null

  const links = BRAND_REFERENCE_LINKS.filter(({ permission }) =>
    hasPermission(role, permission),
  )
    .map((link) => ({ ...link, href: link.getHref({ brand, env }) }))
    .filter(({ href }) => Boolean(href))

  if (!links.length) return null

  return (
    <div className="brand-reference-links">
      <Menu location="bottom-right">
        <Menu.Toggle
          className="brand-reference-links__toggle"
          size="sm"
          variant="ghost-neutral"
        >
          <span className="brand-reference-links__label">
            <Icon aria-hidden="true" size="sm" svg={LinkIcon} />
            Reference links
            <Icon aria-hidden="true" size="sm" svg={ChevronDownIcon} />
          </span>
        </Menu.Toggle>
        {links.map(({ href, id, label }) => (
          <Menu.Item
            key={id}
            aria-label={`Open ${label} (opens in a new tab)`}
            as="a"
            className="brand-reference-links__item"
            href={href}
            leadingDecorator={
              <Icon aria-hidden="true" size="sm" svg={ExternalIcon} />
            }
            rel="noopener noreferrer"
            target="_blank"
          >
            {label}
          </Menu.Item>
        ))}
      </Menu>
    </div>
  )
}

export default BrandReferenceLinks
